import { Injectable } from '@angular/core';
declare var JSEncrypt: any;

@Injectable({
	providedIn: 'root'
})
export class EncryptionService {


	constructor() { }

	private publicKey = `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAplc5zaUoi0de7XQ+l96N
io1VZrCUumuuAMXKt967xPKiaVWtmoI4X+A/QRR03UyoPOCSTa7l+pq0LHzP25B2
T2deH/ICTtZTcgGsTQDeIt/hBqVUFMDqoUhBZgMW6V6UvVDUzKq87Dmn+59VL1FQ
gycsPB+D9Na4wukJaUxNcL0FVzjdEGOh9k1G13J1gBY1oReC72H7Q6lg6CVlEsEI
R+VIuExjFYLInqcuMow9ebV412J8+1VNIJoX9RTQhjw9P1QAsbY7cIkCqgystx++
jauS2G81agHxufx87Q2v+UyVdaSvZLRS+X8aDYNDMKgsDYzyJ0uLnsWRI9FZNLZd
EJbljRPTcCHMjhZxnBUqzdIOgdnxvztQr1VR05/n0qWLyUalvKIrCygl7qbA6/6e
hpeNUKQ2WHr9Ai/UORy+CbdhalVAL50f2efjDpPesXpB0eXkDj8MWGu9vEl1CNo1
UhiRGb2Ink4CUkavKAl9sqQgHgMouZ7gF6emMUHxIg3ccMiEKxEjEJ5iAkOIup69
SkP1GzV5B48wFB605EZjWU09DAcFkG6uej1k89xRS3/O/Cd30RJY4PZYALy+YDCU
04zb/ZPXfaaeFG1mlatgs3c+XUpLNMhs5g25HchoqEKNwgeKq6uJO0k9q9bvNjsC
X4BX+u1VEUVjfug2IxiCbfsCAwEAAQ==
-----END PUBLIC KEY-----`;

	RSAEncrypt(text: string): string {
		const encrypt = new JSEncrypt();
		encrypt.setPublicKey(this.publicKey);
		return encrypt.encrypt(text);
	}
}
